export default "__VITE_ASSET__584c703f__"